<div class="container">
  <mat-card>
    <form [formGroup]="acceptClientTransferForm" (ngSubmit)="submit()">
      <mat-card-content fxLayout="column">
        <mat-form-field (click)="transferDatePicker.open()">
          <mat-label>{{ 'labels.inputs.Transfer Date' | translate }}</mat-label>
          <input matInput [matDatepicker]="transferDatePicker" required formControlName="transferDate" />
          <mat-datepicker-toggle matSuffix [for]="transferDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #transferDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex>
          <mat-label>{{ 'labels.inputs.Note' | translate }}</mat-label>
          <textarea matInput formControlName="note" cdkTextareaAutosize cdkAutosizeMinRows="2"></textarea>
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!acceptClientTransferForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
